import { Box, BoxProps } from "@chakra-ui/react";

export function DesktopOnly(props: BoxProps) {
  return <Box display={["none", null, "block"]} {...props} />;
}
